"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var OptimalMarginGraphDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(OptimalMarginGraphDataConverter, _DataObjectConverter_);

  function OptimalMarginGraphDataConverter() {
    _classCallCheck(this, OptimalMarginGraphDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimalMarginGraphDataConverter).apply(this, arguments));
  }

  return OptimalMarginGraphDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.OptimalMarginGraphDataConverter = OptimalMarginGraphDataConverter;